import { Permission } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { routes } from "@libs/routing/routes.ts";
import { NavLink } from "@ui-components/navigation/Nav.tsx";

import { useAddressBookLinks } from "./useAddressBookLinks.ts";
import { useAdminLinks } from "./useAdminLinks.ts";
import { useAppointmentsLinks } from "./useAppointmentsLinks.ts";
import { useFinanceLinks } from "./useFinanceLinks.ts";
import { useToDoLinks } from "./useToDoLinks.ts";

export const useNavLinks = (): NavLink[] => {
  return [
    {
      name: "Appointments",
      permissions: routes.calendarEvents.basePath.permissions,
      links: useAppointmentsLinks()
    },
    {
      name: "Address book",
      permissions: [Permission.ContactRead, Permission.PatientRead],
      links: useAddressBookLinks()
    },
    {
      name: "To do",
      links: useToDoLinks()
    },
    {
      name: "Admin",
      links: useAdminLinks()
    },
    {
      name: "Finance",
      permissions: [Permission.AccountHistoryAllowed],
      links: useFinanceLinks()
    },
    {
      name: "Reports",
      permissions: routes.reports.basePath.permissions,
      permissionsOperator: routes.reports.basePath.permissionsOperator,
      path: routes.reports.basePath
    }
  ];
};
